/**
 * Domain-level date utility functions
 * These utilities are pure functions that handle date transformations
 * without any external dependencies (following clean architecture)
 */

/**
 * Converts a Date to timestamp (milliseconds since epoch)
 * @param date The date to convert
 * @returns Timestamp in milliseconds
 */
export const toTimestamp = (date: Date): number => {
  return date.getTime();
};

/**
 * Converts a timestamp to Date object
 * @param timestamp Timestamp in milliseconds
 * @returns Date object
 */
export const fromTimestamp = (timestamp: number): Date => {
  return new Date(timestamp);
};

/**
 * Validates if a date is within a reasonable range
 * @param date The date to validate
 * @returns True if date is valid and reasonable
 */
export const isValidDate = (date: Date): boolean => {
  if (!(date instanceof Date) || isNaN(date.getTime())) {
    return false;
  }
  
  // Check if date is within reasonable bounds (1970 to 2100)
  const timestamp = date.getTime();
  const minTimestamp = new Date('1970-01-01').getTime();
  const maxTimestamp = new Date('2100-01-01').getTime();
  
  return timestamp >= minTimestamp && timestamp <= maxTimestamp;
};